export default __webpack_public_path__ + "static/media/65t.7e3a896a.jpg";